<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Representantes</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            fab
            small
            color="primary lighten-5"
            @click="$refs.dialogoImpressaoListagem.abrir()"
          >
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn
            fab
            small
            depressed
            color="primary lighten-5"
            class="ml-2"
            @click="tooglePesquisa"
          >
            <v-icon>search</v-icon>
          </v-btn>

          <!-- <v-btn
            depressed
            color="primary lighten-5"
            @click="$router.push('/representantes/adicionar')"
            v-if="user.tipo == 'administrador'"
            class="hidden-xs-only ml-2"
            >Adicionar</v-btn
          >
          <v-btn
            depressed
            color="primary lighten-5"
            @click="$router.push('/representantes/adicionar')"
            v-if="user.tipo == 'administrador'"
            class="hidden-sm-and-up ml-2"
          >
            <v-icon>add</v-icon>
          </v-btn> -->
        </v-app-bar>

        <v-expand-transition>
          <v-row dense v-show="exibirPesquisa" class="pa-2">
            <v-col cols="12" pa-2>
              <v-text-field
                ref="pesquisa"
                label="Pesquisa"
                v-model="pesquisa"
                prepend-inner-icon="search"
                solo
                background-color="grey lighten-2"
                clearable
                single-line
                hide-details
                placeholder="Pesquisa"
                color="primary"
                @click:clear="tooglePesquisa"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>

        <v-divider />

        <v-data-table
          :search="pesquisa"
          :headers="headers"
          :items="representantes"
          :loading="loading"
          :footer-props="{
            itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }],
            itemsPerPageText: 'Registros Exibidos',
          }"
          :items-per-page="30"
          no-data-text="Sem registros"
          no-results-text="Sem registros"
          loading-text="Carregando dados..."
        >
          <template
            v-if="user.tipo == 'administrador' || user.tipo == 'master'"
            v-slot:item.nome_fantasia="{ item }"
          >
            {{ item.nome_fantasia }}
          </template>
          <template v-if="user.tipo == 'cliente'" v-slot:item.nome="{ item }">
            {{ item.nome }}
            <v-chip
              label
              outlined
              small
              disabled
              v-if="user.tipo == 'cliente' && item.status != 2"
              :color="chipStatus(item.status).cor"
              >{{ chipStatus(item.status).nome }}</v-chip
            >
          </template>

          <template
            v-if="user.tipo == 'administrador' || user.tipo == 'master'"
            class="hidden-xs-only"
            v-slot:item.cnpj="{ item }"
          >
            {{ item.cnpj }}
          </template>

          <template
            v-if="
              user.tipo == 'administrador' ||
                user.tipo == 'cliente' ||
                user.tipo == 'master'
            "
            v-slot:item.local="{ item }"
          >
            {{ item.local }}
          </template>

          <template
            v-if="
              user.tipo == 'administrador' ||
                user.tipo == 'cliente' ||
                user.tipo == 'master'
            "
            v-slot:item.acoes="{ item }"
          >
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  @click="abrirDialogoDados(item)"
                  v-if="
                    user.tipo == 'cliente' ||
                      user.tipo == 'administrador' ||
                      user.tipo == 'master'
                  "
                >
                  <v-list-item-title>
                    <v-icon class="pr-4">list_alt</v-icon>Detalhes
                  </v-list-item-title>
                </v-list-item>

                <v-list-item
                  v-if="user.tipo == 'cliente' && item.status == 1"
                  @click="abrirDialogoDesvinculacao(item)"
                >
                  <v-list-item-title>
                    <v-icon class="pr-4">close</v-icon>Desvincular
                  </v-list-item-title>
                </v-list-item>

                <v-list-item
                  v-if="user.tipo == 'cliente' && item.status == 2"
                  @click="abrirDialogoVinculacao(item)"
                >
                  <v-list-item-title>
                    <v-icon class="pr-4">check</v-icon>Vincular
                  </v-list-item-title>
                </v-list-item>

                <!-- <v-list-item
                  v-if="user.tipo == 'administrador'"
                  @click="
                    $router.push('/representantes/' + item.id + '/editar')
                  "
                >
                  <v-list-item-title>
                    <v-icon class="pr-4">edit</v-icon>Editar
                  </v-list-item-title>
                </v-list-item> -->

                <!-- <v-list-item @click="abrirDialogoExcluir(item)">
                  <v-list-item-title>
                    <v-icon class="pr-4">close</v-icon>Excluir
                  </v-list-item-title>
                </v-list-item> -->

                <!-- <v-list-item @click="abrirDialogoResetar(item)">
                  <v-list-item-title>
                    <v-icon class="pr-4">lock_open</v-icon>Resetar Senha
                  </v-list-item-title>
                </v-list-item> -->
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>

      <as-dialogo
        ref="dialogoExcluir"
        title="Excluir Representante"
        max-width="440px"
        hideCloseButton
      >
        <v-label>Deseja excluir este representante?</v-label>
        <div class="pt-4" style="display: flex; justify-content: flex-end;">
          <v-btn depressed class="mr-4" @click="$refs.dialogoExcluir.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="error"
            @click="excluir"
            :disabled="excluindo"
            :loading="excluindo"
            >Excluir</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoResetar"
        title="Resetar Senha"
        max-width="440px"
        hideCloseButton
      >
        <v-label>Deseja resetar a senha deste representante?</v-label>
        <br /><br />
        <v-label>
          A senha será redefinida para
          <b>123456</b>
        </v-label>
        <div class="pt-8" style="display: flex; justify-content: flex-end;">
          <v-btn depressed class="mr-4" @click="$refs.dialogoResetar.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="error"
            @click="resetar"
            :disabled="resetando"
            :loading="resetando"
            >Resetar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoImpressaoListagem"
        title="Imprimir"
        max-width="440px"
        hideCloseButton
      >
        <v-label>Deseja imprimir a listagem de representantes?</v-label>
        <div class="pt-8" style="display: flex; justify-content: flex-end;">
          <v-btn
            depressed
            class="mr-4"
            @click="$refs.dialogoImpressaoListagem.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="imprimirListagem"
            :disabled="imprimindo"
            :loading="imprimindo"
            >Imprimir</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoDados"
        title="Dados do Representante"
        max-width="1200px"
      >
        <v-form>
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Nome"
                v-model="representante.nome_fantasia"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="CNPJ"
                v-model="representante.cnpj"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Logradouro"
                v-model="representante.endereco.rua"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                label="Complemento"
                v-model="representante.endereco.complemento"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-text-field
                label="Número"
                v-model="representante.endereco.numero"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                label="Bairro"
                v-model="representante.endereco.bairro"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Cidade"
                v-model="representante.endereco.cidade"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Estado"
                v-model="representante.endereco.estado"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Celular"
                v-model="representante.endereco.celular"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Telefone"
                v-model="representante.endereco.telefone"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Email"
                v-model="representante.endereco.email"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </as-dialogo>

      <as-dialogo
        ref="dialogoVinculacao"
        title="Vinculação de Representante"
        max-width="728px"
        hideCloseButton
      >
        <p>Tem certeza que deseja se vincular a este representante?</p>
        <div slot="botoes">
          <v-btn
            color="white"
            @click="$refs.dialogoVinculacao.fechar()"
            :disabled="loading"
            >Cancelar</v-btn
          >
          <v-btn color="primary" @click="vincular" :loading="loading"
            >Confirmar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoDesvinculacao"
        title="Desvinculação de Representante"
        max-width="728px"
        hideCloseButton
      >
        <p>Tem certeza que deseja se desvincular deste representante?</p>
        <div slot="botoes">
          <v-btn
            color="white"
            @click="$refs.dialogoDesvinculacao.fechar()"
            :disabled="loading"
            >Cancelar</v-btn
          >
          <v-btn color="primary" @click="desvincular" :loading="loading"
            >Confirmar</v-btn
          >
        </div>
      </as-dialogo>
    </v-container>
  </div>
</template>

<script>
import Services from "@/services/services.js";
import ServiceClientes from "@/services/clientes.js";
import ServiceRepresentantes from "@/services/representantes.js";
import ServiceImpressoes from "@/services/impressoes.js";

export default {
  name: "MinhasRepresentacoes",
  data() {
    return {
      user: {},
      loading: false,
      pesquisa: "",
      exibirPesquisa: false,
      excluindo: false,
      resetando: false,
      representantes: [],
      headers: [],
      status: {
        0: {
          nome: "Pendente",
          cor: "red",
        },
        1: {
          nome: "Confirmado",
          cor: "green",
        },
      },
      representante: {
        nome_fantasia: "",
        cnpj: "",
        endereco: {
          rua: "",
          complemento: "",
          numero: "",
          bairro: "",
          cidade_nome: "",
          estado_nome: "",
        },
        telefone: "",
        celular: "",
        email: "",
      },
      imprimindo: false,
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user.tipo == "cliente") {
      this.headers = [
        { text: "Nome", value: "nome", width: "50%" },
        { text: "Cidade", value: "cidade", width: "45%" },
        { text: "", value: "", width: "5%", sortable: false },
      ];
    } else if (
      this.user.tipo == "administrador" ||
      this.user.tipo == "master"
    ) {
      this.headers = [
        { text: "Nome", value: "nome_fantasia", width: "45%" },
        {
          text: "CPF/CNPJ",
          value: "cnpj",
          width: "20%",
          class: "hidden-xs-only",
        },
        { text: "Cidade", value: "local", width: "30%" },
        { text: "", value: "acoes", width: "5%", sortable: false },
      ];
    }
    this.listar();
  },
  methods: {
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    chipStatus(status) {
      return this.status[status];
    },
    async listar() {
      try {
        this.loading = true;
        if (this.user.tipo == "cliente") {
          let response = await ServiceClientes.representantes(
            this.user.cliente_id
          );
          this.representantes = response.data.representantes;
        } else if (
          this.user.tipo == "administrador" ||
          this.user.tipo == "master"
        ) {
          let response = await ServiceRepresentantes.listar();
          this.representantes = response.data.representantes;
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao buscar representantes", error);
      } finally {
        this.loading = false;
      }
    },
    abrirDialogoExcluir(representante) {
      this.representante = this.clone(representante);
      this.$refs.dialogoExcluir.abrir();
    },
    async excluir() {
      try {
        this.excluindo = true;

        let response = await ServiceRepresentantes.excluir(
          this.representante.id
        );
        if (response.data.status == 1) {
          this.$eventbus.notificar(response.data.msg);
          this.listar();
        } else if (response.data.status == 2) {
          this.$eventbus.erro(response.data.msg);
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao excluir representante");
      } finally {
        this.excluindo = false;
        this.$refs.dialogoExcluir.fechar();
      }
    },
    abrirDialogoResetar(representante) {
      this.representante = this.clone(representante);
      this.$refs.dialogoResetar.abrir();
    },
    async resetar() {
      try {
        this.resetando = true;
        await ServiceRepresentantes.resetarSenha(this.representante.id);

        this.$eventbus.notificar(
          "Senha resetada com sucesso. Nova senha: 123456"
        );
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao resetar a senha deste representante");
      } finally {
        this.resetando = false;
        this.listar();
        this.$refs.dialogoResetar.fechar();
      }
    },
    async imprimirListagem() {
      try {
        this.imprimindo = true;
        let impressao = JSON.parse(localStorage.getItem("impressao_remota"))
          ? "remota"
          : "local";
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceImpressoes.listarRepresentantes({
          impressao,
          rodada_id: this.$store.state.rodada.id,
        });
        if (impressao == "local") {
          this.$store.commit("setPdfUrl", pdf);
        } else {
          this.$eventbus.notificar(
            "Impressão encaminhada para a Ilha de Impressão com sucesso"
          );
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao imprimir listagem de representantes");
      } finally {
        this.imprimindo = false;
        this.$refs.dialogoImpressaoListagem.fechar();
      }
    },

    abrirDialogoVinculacao(representante) {
      // this.representante = representante;

      this.representante.cidade = representante.cidade;
      this.representante.id = representante.id;
      this.representante.nome = representante.nome;
      this.representante.status = representante.status;

      this.$refs.dialogoVinculacao.abrir();
    },
    async vincular() {
      try {
        this.loading = true;
        let response = await ServiceClientes.representanteRelacionar(
          this.user.cliente_id,
          this.representante,
          1
        );
        if (response.data.status == 1) {
          this.representante = {
            nome_fantasia: "",
            cnpj: "",
            endereco: {
              rua: "",
              complemento: "",
              numero: "",
              bairro: "",
              cidade_nome: "",
              estado_nome: "",
            },
            telefone: "",
            celular: "",
            email: "",
          };
          this.listar();
          this.$refs.dialogoVinculacao.fechar();
        } else {
          if (response.data.status == 401) {
            this.$root.$children[0].makeLogOff = true;
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    abrirDialogoDesvinculacao(representante) {
      this.representante.cidade = representante.cidade;
      this.representante.id = representante.id;
      this.representante.nome = representante.nome;
      this.representante.status = representante.status;

      this.$refs.dialogoDesvinculacao.abrir();
    },
    async desvincular() {
      try {
        this.loading = true;
        let response = await ServiceClientes.representanteRelacionar(
          this.user.cliente_id,
          this.representante,
          0
        );
        if (response.data.status == 1) {
          this.representante = {
            nome_fantasia: "",
            cnpj: "",
            endereco: {
              rua: "",
              complemento: "",
              numero: "",
              bairro: "",
              cidade_nome: "",
              estado_nome: "",
            },
            telefone: "",
            celular: "",
            email: "",
          };
          this.listar();
          this.$refs.dialogoDesvinculacao.fechar();
        } else {
          if (response.data.status == 401) {
            this.$root.$children[0].makeLogOff = true;
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async abrirDialogoDados(representante) {
      try {
        this.representante = representante;
        this.$refs.dialogoDados.abrir();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
